"use client";

export const OurStorySection = () => {
  return (
    <div id="our-story" className="sticky top-0 z-0 flex flex-col items-center justify-center pt-6 px-4 md:px-16 lg:px-32 bg-[#212121]">
      <div className="w-full max-w-[1280px]">
        {/* Story */}
        <div className="sticky top-0 h-[655px] flex flex-col lg:flex-row items-center gap-6 pt-8 md:pt-16 lg:pt-[180px]">
          {/* Mobile: graphic on top */}
          <div className="lg:hidden flex items-center justify-center shrink-0">
            <video
              autoPlay
              muted
              loop
              playsInline
              aria-hidden="true"
              preload="none"
              poster="/images/about-poster.webp"
              className="w-[188px] h-[190px] md:hidden rounded-2xl object-cover"
            >
              <source src="/videos/KEY-About-512.webm" type="video/webm" />
              <source src="/videos/KEY-About-512.mp4" type="video/mp4" />
            </video>
          </div>

          {/* Text content.

              Previously this was two subtrees — a `hidden md:block` desktop
              pair and an `md:hidden` mobile paragraph — carrying the same 40
              words. CSS hid one of them from readers, but both stayed in the
              HTML, so every crawler and text extractor read the whole story
              twice (visible in the rendered text of `/`, and in the copy an
              answer engine would quote back).

              One subtree now serves both. The inner wrapper is `md:contents`,
              so on desktop the h2 and p become direct children of the flex
              column and pick up its gap-6 as before; below md the wrapper is a
              plain block and the two elements are `inline`, reflowing into the
              single continuous paragraph the mobile layout had. */}
          <div className="flex flex-col gap-6 shrink-0 lg:w-[580px]">
            <div className="text-[24px] leading-8 tracking-[-0.72px] md:contents">
              <h2 className="inline md:block font-normal text-[#f8f7f4] md:text-[32px] lg:text-[40px] md:leading-[40px] lg:leading-[56px] md:tracking-[-0.96px] lg:tracking-[-1.2px]">
                We started Keystone with a simple belief. Growing your business
                shouldn&apos;t be so complicated.{" "}
              </h2>
              <p className="inline md:block text-[#c4c4c4] md:text-[20px] md:leading-7 md:tracking-[-0.04px]">
                We create a family of apps that work together from day one,
                helping you build a great customer experience and a simpler
                workflow for you and your team.
              </p>
            </div>
          </div>

          {/* Desktop/Tablet: graphic on the right */}
          <div className="hidden md:flex flex-1 h-full items-center justify-center">
            <video
              autoPlay
              muted
              loop
              playsInline
              aria-hidden="true"
              preload="none"
              poster="/images/about-poster.webp"
              className="w-full max-w-md rounded-2xl"
            >
              <source src="/videos/KEY-About-512.webm" type="video/webm" />
              <source src="/videos/KEY-About-512.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};
